import fetchModels from "../../mixin/store/api/fetchModels";
import fetchModel from "@/mixin/store/api/fetchModel";
import changeOrPushModel from "@/mixin/store/api/changeOrPushModel";
import pushModel from "@/mixin/store/api/pushModel";
import deleteModel from "@/mixin/store/api/deleteModel";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchIncomeAndOutcomeCategories(context, search) {
            return fetchModels(context, 'income_and_outcome_categories', search.page + '&order[id]=desc', 'updateIncomeAndOutcomeCategories');
        },
        fetchIncomeAndOutcomeCategoriesAll(context) {
            return fetchModels(context, 'income_and_outcome_categories', null, 'updateIncomeAndOutcomeCategories');
        },
        fetchIncomeAndOutcomeCategory(context, id) {
            return fetchModel(context, 'income_and_outcome_categories', id, 'updateIncomeAndOutcomeCategory');
        },
        putIncomeAndOutcomeCategory(context, data) {
            return changeOrPushModel(context, 'income_and_outcome_categories', data, 'updateIncomeAndOutcomeCategory')
        },
        pushIncomeAndOutcomeCategory(context, data) {
            return pushModel(context, 'income_and_outcome_categories', data)
        },
        deleteIncomeAndOutcomeCategory(context, id) {
            return deleteModel(context, 'income_and_outcome_categories', id);
        },
        searchIncomeAndOutcomeCategory(context, searchItem) {
            let url = "income_and_outcome_categories?page=" + searchItem.page;
            // eslint-disable-next-line no-unused-vars
            let isSearch= false


            if (searchItem.name !== null) {
                url = url + '&name=' + searchItem.name
                isSearch = true
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)
                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }
                    context.commit('updateIncomeAndOutcomeCategories', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateIncomeAndOutcomeCategories(state, data) {
            state.incomeAndOutcomeCategories = data
        },
        updateIncomeAndOutcomeCategory(state, data) {
            state.incomeAndOutcomeCategory = data
        },
    },
    state: {
        incomeAndOutcomeCategories: {
            models: [],
            totalItems: 0,
        },
        incomeAndOutcomeCategory: {
            id: null,
            name: null,
            isIncome: false,
        }
    },
    getters: {
        getIncomeAndOutcomeCategories(state) {
            return state.incomeAndOutcomeCategories.models
        },
        getIncomeAndOutcomeCategoriesTotalCount(state) {
            return state.incomeAndOutcomeCategories.totalItems
        },
        getIncomeAndOutcomeCategory(state) {
            return state.incomeAndOutcomeCategory
        },
    },
}